import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import Shape from '../Shape/Shape';
import classes from './Preview.styles.less';
export default function Preview({ values }) {
    return (_jsx("div", { className: classes.wrapper, children: _jsx("div", { className: cx(classes.shapeWrapper, classes[values.position], classes[values.direction]), children: _jsx(Shape, { shape: values.type, style: {
                    width: `${values.width}%`,
                    height: values.height,
                    fill: values.color,
                } }) }) }));
}
